/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AclAccessRoleList } from '../../models/acl-access-role-list';

export interface GetAclAccessDataForEdit$Params {
  arid?: number;
  orid?: number;
}

export function getAclAccessDataForEdit(http: HttpClient, rootUrl: string, params?: GetAclAccessDataForEdit$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AclAccessRoleList>>> {
  const rb = new RequestBuilder(rootUrl, getAclAccessDataForEdit.PATH, 'get');
  if (params) {
    rb.query('arid', params.arid, {});
    rb.query('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AclAccessRoleList>>;
    })
  );
}

getAclAccessDataForEdit.PATH = '/api/AclRole/aclAccessDataForEdit';
